/**
 * Classe responsável pela funcionalidade de implementar o filtro de grupos.
 * @author: Adalto Junior <adaltojunior@sagaranatech.com>
 * Date: 17/09/13
 * Time: 17:28
 */


Greenmile.GroupPermissions = Greenmile.GroupPermissions || {};

Greenmile.GroupPermissions.FilterGroups = (function () {

    function FilterGroups () {

        Monet.UI.AjaxFilter.apply(this, arguments);

        this.createBaseStructure();

        this.callbackForSearch = function () {

            var input          = this.rootEl.querySelector('input[type="text"]'),
                filterToSearch = {};

            if (input) {

                var router = new App.Routers.GroupPermissions();

                filterToSearch = {
                    attr: 'name',
                    "eq": input.value,
                    "matchMode": "ANYWHERE"
                };

                router.getGroupsAndCreateList(filterToSearch);

            }

        };

    }

    FilterGroups.prototype = new Monet.UI.AjaxFilter();

    return FilterGroups;

})();